import React from 'react';
import type { Site } from './types';
import { getPublishedDomain } from '../../utils/publishedUrl';

interface DeleteSiteModalProps {
  site: Site;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export const DeleteSiteModal: React.FC<DeleteSiteModalProps> = ({
  site,
  onConfirm,
  onCancel,
  isSubmitting,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Delete Site</h3>
      <p className="text-gray-600 mb-2">
        Are you sure you want to delete <strong>{site.name}</strong>?
      </p>
      <p className="text-gray-600 mb-6">
        This will permanently delete the site and all its pages. This action cannot be undone.
      </p>
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
        <p className="text-sm text-yellow-800">
          <strong>Subdomain:</strong> {site.subdomain}.{getPublishedDomain()}
        </p>
        {site.customDomain && (
          <p className="text-sm text-yellow-800 mt-1">
            <strong>Custom Domain:</strong> {site.customDomain}
          </p>
        )}
        <p className="text-sm text-yellow-800 mt-1">
          <strong>Owner:</strong> {site.userName}
        </p>
      </div>
      <div className="flex space-x-4">
        <button onClick={onConfirm} disabled={isSubmitting} className="btn-danger flex-1">
          {isSubmitting ? 'Deleting...' : 'Delete Site'}
        </button>
        <button onClick={onCancel} disabled={isSubmitting} className="btn-secondary flex-1">
          Cancel
        </button>
      </div>
    </div>
  </div>
);
